import React, { useCallback, useContext, useState } from "react";
import { Tooltip } from "@material-ui/core";
import { CgArrowTopRightR } from "react-icons/cg";
import BaseAccordionTable, { Status, IconStatus } from "../BaseAccordionTable";
import DirectsModal from "./DirectsModal";
import { useHistory } from "react-router-dom";
import "./styles.scss";
import moment from "moment";
import { getDetailsUnificationImpactEvulations } from "services/NexiDigitalAPI";
import { AuthContext } from "context/AuthContext";

const TrainingAccordionTable = ({ training }) => {
  const { loginData }: { loginData: any } = useContext(AuthContext);
  const history = useHistory();
  const [showDirectsModal, setShowDirectsModal] = useState(false);
  const [selectedClassData, setSelectedClassData] = useState(null);

  const loadData = useCallback(async () => {
    if (training.nodeCode) {
      try {
        const result = await getDetailsUnificationImpactEvulations(training.nodeCode, loginData?.userid)
        return {
          data: result.data,
          totalRecords: result.data.totalRecords,
        };
      } catch (e) {
        throw (e)
      } finally {

      }
    }
  }, [loginData?.userid, training.nodeCode]);

  const getStatusFromClass = (classItem) => {
    if (classItem.status === "Não iniciado") return Status.NOTSTARTED;
    if (classItem.status === "Em andamento") return Status.PENDING;
    return Status.NOTSTARTED;
  };

  const handleDirectsClick = (classItem) => {
    setSelectedClassData({
      trainingTitle: training.title,
      classTitle: classItem.name,
      idTeam: classItem.idTeam,
    });
    setShowDirectsModal(true);
  };

  const handleCloseDirectsModal = () => {
    setShowDirectsModal(false);
    setSelectedClassData(null);
  };

  const columns = [
    {
      name: "Turma",
      selector: "name",
      sortable: false,
      wrap: true,
      left: true,
      cell: ({ name }) => (
        <div className="column-cell left">
          <span>{name}</span>
        </div>
      ),
    },
    {
      name: "Pessoas avaliadas",
      selector: "direct",
      sortable: false,
      center: true,
      wrap: true,
      cell: ({ direct, directsLink, directsTooltip, highlight, ...classItem }) => (
        <div className="column-cell center">
          {direct > 1 ? (
            <Tooltip title={directsTooltip || "Visualizar pessoas"} placement="top">
              <button
                type="button"
                className="directs-link"
                onClick={() => handleDirectsClick({ direct, ...classItem })}
              >
                {`${direct} ${direct === 1 ? "pessoa" : "pessoas"}`}
              </button>
            </Tooltip>
          ) : (
            <span>{`${direct} ${direct === 1 ? "pessoa" : "pessoas"}`}</span>
          )}
        </div>
      ),
    },
    {
      name: "Disponível em",
      selector: "available",
      sortable: false,
      center: true,
      wrap: true,
      cell: ({ creationDate }) => (
        <div>
          <span>{creationDate ? moment(creationDate).format("MMM D, YYYY") : ""}</span>
        </div>
      ),
    },
    {
      name: "Prazo",
      selector: "expirationDate",
      sortable: false,
      center: true,
      wrap: true,
      cell: ({ expirationDate }) => (
        <div>
          <span>{expirationDate ? moment(expirationDate).add(30, "days").format("MMM D, YYYY") : ""}</span>
        </div>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: false,
      center: true,
      wrap: true,
      cell: (classItem) => (
        <div className="column-cell center">
          <IconStatus status={getStatusFromClass(classItem)} />
        </div>
      ),
    },
    {
      name: "Ação",
      sortable: false,
      selector: "external",
      width: "200px",
      center: true,
      wrap: true,
      cell: ({ idQuestionnaire }) => (
        <div className="column-cell center">
          <div className="groupActions" key={idQuestionnaire}>
            <Tooltip title="Ir para avaliação" placement="top">
              <button
                className="btn btn-sm float-right icon-leave"
                onClick={() => {
                  history.push(`/impact-evaluation/${idQuestionnaire}/${loginData?.userid}`);
                }}
              >
                <CgArrowTopRightR />
              </button>
            </Tooltip>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="TrainingAccordionTable">
      <BaseAccordionTable
        item={training}
        title={training.title}
        subtitle={null}
        columns={columns}
        loadData={loadData}
        noDataMessage="Sem turmas encontradas"
        enablePagination={false}
      />
      {selectedClassData && (
        <DirectsModal
          show={showDirectsModal}
          onHide={handleCloseDirectsModal}
          {...selectedClassData}
        />
      )}
    </div>
  );
};

export default TrainingAccordionTable;
